import { Grid, Button, Typography } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";


interface SubscriptionSuspendModalProps {
    isVisible: boolean;
    close: () => void;
    suspend: () => void;
}

export function SubscriptionSuspendModal({ isVisible, close, suspend }: SubscriptionSuspendModalProps): JSX.Element {
    return (
        <GeneralModal
            title="Suspend subscription"
            description="Are you sure you want to suspend this subscription?"
            visible={isVisible}
            onClose={() => close()}
            onSubmit={suspend}
            modalWidth="560px"
        >
            <GeneralModal.ContentArea>
                <Grid container>
                    <Grid item xs={12}>
                        This will suspend the subscription and the user will not be able to use the subscription until it is activated again.
                    </Grid>
                </Grid>
            </GeneralModal.ContentArea>
            <GeneralModal.ButtonArea>
                <Button onClick={() => close()}>
                    <Typography
                        variant="button"
                        component="p"
                        color="primary"
                    >
                        Cancel
                    </Typography>
                </Button>
                <PrimaryButton
                    onClick={() => suspend()}
                    title="Suspend"
                />
            </GeneralModal.ButtonArea>
        </GeneralModal>
    );
}
